import { render, staticRenderFns } from "./ChangeContentDocument.vue?vue&type=template&id=5d4802d4&scoped=true"
import script from "./ChangeContentDocument.vue?vue&type=script&lang=js"
export * from "./ChangeContentDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4802d4",
  null
  
)

export default component.exports